import { AxiosCall, CancelTokenSource } from "../axios";
import { serializeQueryParams } from "./PaymentHistoryService";
import { ServiceSuccessResponseType } from "./service-mappers/BaseMapper";
import { ArrayRows } from "./service-mappers/ClinicServiceMapper";
import { ArrayResponse } from "./service-mappers/CommonServiceMapper";

export const getGatherFeedbackList = async (
  clinicGroupId: number,
  clinicId: number,
  options: any,
  cancelToken?: CancelTokenSource
): Promise<ServiceSuccessResponseType<ArrayResponse<ArrayRows>>> => {
  const queryParams = serializeQueryParams(options);
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}/patient-reviews?${queryParams}`;
  return AxiosCall.get(url, cancelToken);
};

export const remindAgain = async (
  clinic_group_id: number | string,
  clinic_id: number,
  appointment_id: number
): Promise<ServiceSuccessResponseType<ArrayResponse<ArrayRows>>> => {
  return AxiosCall.post(`/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient-reviews/send-appointment-review/${appointment_id}`, {});
};

export const updateGatherFeedBackAppointment = async(
  clinic_group_id: number | string,
  clinic_id: number,
  appointment_id: number,
  payload: {
    review_type: string;
  }
): Promise<ServiceSuccessResponseType<ArrayResponse<ArrayRows>>> => {
  return AxiosCall.put(`/clinic-group/${clinic_group_id}/clinic/${clinic_id}/appointment/${appointment_id}/patient-review`, payload)
}